import { c as createUnhead, r as registerPlugin } from './unhead.CfgPMHXt.mjs';
import { c as createHooks } from './unhead.DvIxXxuO.mjs';
import { c as createDomRenderer } from './unhead.pv34ME7O.mjs';

const P = { critical: -8, high: -1, low: 2 };
const tagWeight = (tag) => typeof tag.tagPriority === "number" ? tag.tagPriority : 100 + (P[tag.tagPriority] || 0);
function createHead(options = {}) {
  options.document = options.document || (typeof window !== "undefined" ? document : void 0);
  const renderer = options.render || createDomRenderer({ document: options.document });
  const initialPayload = options.document?.head.querySelector('script[id="unhead:payload"]')?.innerHTML || false;
  const core = createUnhead(renderer, { document: options.document, propResolvers: options.propResolvers, _tagWeight: tagWeight, init: [] });
  const hooks = createHooks(options.hooks);
  let dirty = false;
  const head = {
    ...core,
    ssr: false,
    hooks,
    use: (p) => registerPlugin(head, p),
    get dirty() {
      return dirty;
    },
    set dirty(v) {
      dirty = v;
    },
    render: () => renderer(head),
    invalidate() {
      for (const e of core.entries.values()) delete e._tags;
      dirty = true;
      hooks.callHook("entries:updated", head);
    },
    push(input, _options) {
      const onRendered = _options?.onRendered;
      const unhook = onRendered ? hooks.hook("dom:rendered", onRendered) : void 0;
      const active = core.push(input, _options);
      core.entries.get(active._i)._o = input;
      dirty = true;
      hooks.callHook("entries:updated", head);
      return {
        _i: active._i,
        patch(input2) {
          active.patch(input2);
          dirty = true;
          hooks.callHook("entries:updated", head);
        },
        dispose() {
          unhook?.();
          if (core.entries.has(active._i)) {
            active.dispose();
            head.invalidate();
          }
        }
      };
    }
  };
  hooks.hook("entries:updated", () => {
    renderer(head);
  });
  options.plugins?.forEach((p) => registerPlugin(head, p));
  initialPayload && head.push(JSON.parse(initialPayload));
  options.init?.forEach((e) => e && head.push(e));
  return head;
}

export { createHead as c };
